import { CardError } from './CardError';
import { CardGroup } from './CardGroup';
import { CardLink } from './CardLink';
import { CardRoot } from './CardRoot';

export const Card = {
  Root: CardRoot,
  Link: CardLink,
  Group: CardGroup,
  Error: CardError,
};
